var React = require('react');

function Download (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("path",{"d":"M63 1.5H5c-.966 0-1.841.392-2.475 1.025A3.489 3.489 0 001.5 5v76c0 .966.392 1.841 1.025 2.475A3.489 3.489 0 005 84.5h49.759a1.5 1.5 0 001.06-.438l10.24-10.22a1.5 1.5 0 00.441-1.062V5c0-.966-.392-1.841-1.025-2.475A3.489 3.489 0 0063 1.5z","stroke":"currentColor","strokeWidth":"3","key":0}),React.createElement("rect",{"fill":"currentColor","x":"19","y":"60","width":"30","height":"3","rx":"1.5","key":1}),React.createElement("path",{"d":"M53 84V74a3 3 0 013-3h10","stroke":"currentColor","strokeWidth":"3","key":2}),React.createElement("path",{"d":"M29 27h10v16h8L34 56 21 43h8V27z","stroke":"currentColor","strokeWidth":"3","fill":"currentColor","strokeLinejoin":"round","key":3})]));
}

Download.defaultProps = {"width":"68","height":"86","viewBox":"0 0 68 86"};

module.exports = Download;

Download.default = Download;
